module.exports = __webpack_public_path__ + "static/media/virtu-brand.87203836.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/virtu-brand.svg
// module id = 1306
// module chunks = 0